<template>
  <b-modal
    id="selectOption"
    size="sm"
    header-bg-variant="lisaweb"
    ok-only
    ok-title="Annulla e chiudi"
    ok-variant="-transparent"
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    @hidden="onModalHidden"
  >
    <template v-if="title" #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <span>{{ title }}</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel()"
      >
        <base-icon name="close" width="14" height="14" />
      </button>
    </template>

    <b-row v-if="description">
      <div class="col-md-12 mb-3">{{ description }}</div>
    </b-row>
    <validation-observer
      style="height: 600px"
      ref="observer"
      v-slot="{ handleSubmit, invalid }"
    >
      <div class="mt-3">
        <base-month-picker
          name="setup_at"
          label="Data istanziamento SDD"
          v-model="form.setup_at"
          :rules="{ required: true }"
        />
      </div>
      <div>
        <base-select
          v-model="form.bank_account_id"
          name="bank"
          label="Banca"
          :rules="{ required: true }"
          :options="bank_accounts"
          @select="onSelectOption"
        />
      </div>
      <div>
        <base-select
          v-model="form.insurers_id"
          name="company"
          label="Compagnia assicuratrice"
          :options="companies"
        />
        <!--
          <base-select
            v-model="form.insurers_id"
            name="company"
            label="Compagnie assicuratrici"
            :options="companies"
            :multiple="true"
            :taggable="true"
            :closeOnSelect="false"
          />
          <b-button
            :pressed.sync="myToggleCompanies"
            variant="light"
            class="mb-2"
            @click="
              myToggleCompanies ? selectAllCompanies() : deselectAllCompanies()
            "
            >{{
              myToggleCompanies ? "Deseleziona tutti" : "Seleziona tutti"
            }}</b-button
          >
          -->
      </div>
      <div class="actions justify-content-end">
        <b-button
          @click="handleSubmit(createEvent)"
          type="button"
          :disabled="invalid"
          variant="primary"
          size="sm"
          class="btn--smaller"
        >
          Salva
        </b-button>
      </div>
    </validation-observer>
  </b-modal>
</template>
<script>
// import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseMonthPicker from "@/components/form/BaseMonthPicker";
import BaseSelect from "@/components/form/BaseSelect";
import { mapGetters } from "vuex";
import FormMixin from "@/mixins/FormMixin";
import moment from "moment";
import BaseIcon from "@/components/BaseIcon";
moment.locale("it");

export default {
  mixins: [FormMixin],
  data() {
    return {
      myToggleCompanies: false,
      companies: [],
      bank_accounts: [],
      form: {
        setup_at: null,
        insurers_id: [],
        bank_account_id: null,
      },
    };
  },
  components: {
    BaseIcon,
    BaseSelect,
    BaseMonthPicker,
    // BaseDatepicker,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  computed: {},
  beforeMount() {},
  created() {
    this.companies = this.getInsurers();
    this.bank_accounts = this.getBankAccounts();
  },
  methods: {
    onModalHidden() {
      this.form.setup_at = null;
      this.form.bank_account_id = null;
      this.form.insurers_id = [];
    },
    hideModal() {
      this.$bvModal.hide("selectOption");
    },
    createEvent() {
      const formatted_setup_at = moment(this.form.setup_at).format("YYYY-MM");
      const days_in_month = moment(this.form.setup_at, "YYYY-MM").daysInMonth();
      this.form.setup_at = `${formatted_setup_at}-${days_in_month}`;
      this.$emit("create", this.form);
      this.hideModal();
    },
    onSelectOption(selected) {
      this.option = selected;
    },
    selectAllCompanies() {
      this.form.insurers_id = this.companies.map((e) => e.value);
    },
    deselectAllCompanies() {
      this.form.insurers_id = [];
    },
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getBankAccounts: "bank_accounts",
    }),
  },
};
</script>
<style lang="scss" scoped>
.modal-body .row > * {
  width: 100%;
}
.modal-body .actions {
  display: flex;
  justify-content: space-between;
  margin: 20px 0 0;
}
</style>
